module.exports = __webpack_public_path__ + "static/img/huijiao15.16a3f3c1.png";